import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerInput = ({ date, fun, text, startDate }) => {
  return (
    <div className=" mr-3 lg:mr-4">
      <DatePicker
        type={"date"}
        className="date-button px-3 max-w-[700px] w-[100%] lg:w-[149px] ml-2"
        selected={date}
        onChange={(e) => fun(e)}
        placeholderText={text}
        dateFormat=" d MMMM yyyy"
        minDate={startDate}
      />
      {/* <img className="lg:pr-[2rem]" src={calender} alt="" /> */}
    </div>
  );
};

export default DatePickerInput;
